import { formatBytes } from "@utils/general";
import {
  FiUploadCloud,
  FiTrash2,
  FiAlertTriangle,
  FiXCircle,
  FiCheckCircle,
} from "react-icons/fi";
import { useFileInput } from "./Root";

export interface FileItemProps {
  name: string;
  size: number;
  index: number;
  status?: string;
}
export function FileItem({ name, size, index, status }: FileItemProps) {
  const { onDeleted } = useFileInput();
  return (
    <div
      key={name}
      className={`tw-group tw-flex tw-items-start tw-gap-4 tw-rounded-lg tw-border tw-p-4 ${
        status === "error"
          ? "tw-border-red-600"
          : status === "warning"
          ? "tw-border-yellow-300"
          : status === "success"
          ? "tw-border-emerald-500"
          : "tw-border-zinc-200"
      }`}
    >
      <div className="tw-rounded-full tw-border-4 tw-border-violet-100 tw-bg-violet-200 tw-text-violet-600">
        <FiUploadCloud className="tw-h-4 tw-w-4" />
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-1">
        <div className="tw-flex tw-flex-col">
          <span className="tw-text-sm tw-font-medium tw-text-zinc-700">
            {name}
          </span>
          <span className="tw-text-sm tw-text-zinc-500">
            {formatBytes(size)}
          </span>
        </div>
        <div className="tw-flex tw-w-full tw-items-center tw-gap-3">
          <div className="tw-h-2 tw-flex-1 tw-rounded-full tw-bg-zinc-100">
            <div
              className="tw-h-2 tw-w-4/5 tw-rounded-full tw-bg-violet-600"
              style={{ width: "100%" }}
            />
          </div>
          <span className="tw-text-sm tw-font-medium tw-text-zinc-700">
            100%
          </span>
        </div>
      </div>
      <button type="button" onClick={() => onDeleted(index)}>
        <FiTrash2 className="tw-h-4 tw-w-4 tw-text-blue-500" />
      </button>
      {status === "error" && (
        <button type="button">
          <FiXCircle className="tw-h-4 tw-w-4 tw-text-red-600" />
        </button>
      )}
      {status === "warning" && (
        <button type="button">
          <FiAlertTriangle className="tw-h-4 tw-w-4 tw-text-yellow-300" />
        </button>
      )}
      {status === "success" && (
        <button type="button">
          <FiCheckCircle className="tw-h-4 tw-w-4 tw-text-emerald-500" />
        </button>
      )}
    </div>
  );
}
